/* eslint-disable no-unused-vars */
import { ElementType } from 'react';

export interface FacetOption {
  value: string;
  label: string;
}

export interface Facet {
  key: string;
  label: string;
  icon: ElementType;
  anyLabel: string;
  options: FacetOption[];
  values: string[];
  apply: (values: string[]) => void;
  multiple?: boolean;
  searchable?: boolean;
  onSearchChange?: (term: string) => void;
  loading?: boolean;
}

export const toggleFacetValue = (values: string[], value: string, multiple = false): string[] => {
  if (!multiple) return values.includes(value) ? [] : [value];
  return values.includes(value) ? values.filter((entry) => entry !== value) : [...values, value];
};

export const normalizeText = (value: string): string =>
  value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();
